
// @ts-nocheck
import locale__app_template1_locales_en_json from "../locales/en.json";
import locale__app_template1_locales_ru_json from "../locales/ru.json";
import locale__app_template1_locales_tr_json from "../locales/tr.json";
import locale__app_template1_locales_de_json from "../locales/de.json";


export const localeCodes =  [
  "en",
  "ru",
  "tr",
  "de"
]

export const localeLoaders = {
  "en": [{ key: "../locales/en.json", load: () => Promise.resolve(locale__app_template1_locales_en_json), cache: true }],
  "ru": [{ key: "../locales/ru.json", load: () => Promise.resolve(locale__app_template1_locales_ru_json), cache: true }],
  "tr": [{ key: "../locales/tr.json", load: () => Promise.resolve(locale__app_template1_locales_tr_json), cache: true }],
  "de": [{ key: "../locales/de.json", load: () => Promise.resolve(locale__app_template1_locales_de_json), cache: true }]
}

export const vueI18nConfigs = [
  
]

export const nuxtI18nOptions = {
  "experimental": {
    "localeDetector": "",
    "switchLocalePathLinkSSR": false,
    "autoImportTranslationFunctions": false
  },
  "bundle": {
    "compositionOnly": true,
    "runtimeOnly": false,
    "fullInstall": true,
    "dropMessageCompiler": false
  },
  "compilation": {
    "jit": true,
    "strictMessage": true,
    "escapeHtml": false
  },
  "customBlocks": {
    "defaultSFCLang": "json",
    "globalSFCScope": false
  },
  "vueI18n": "",
  "locales": [
    {
      "code": "en",
      "iso": "en-US",
      "name": "English",
      "dir": "ltr",
      "files": [
        "locales/en.json"
      ]
    },
    {
      "code": "ru",
      "iso": "ru-RU",
      "name": "Russian",
      "dir": "ltr",
      "files": [
        "locales/ru.json"
      ]
    },
    {
      "code": "tr",
      "iso": "tr-TR",
      "name": "Turkish",
      "dir": "ltr",
      "files": [
        "locales/tr.json"
      ]
    },
    {
      "code": "de",
      "dir": "ltr",
      "iso": "de-DE",
      "name": "German",
      "files": [
        "locales/de.json"
      ]
    }
  ],
  "defaultLocale": "en",
  "defaultDirection": "ltr",
  "routesNameSeparator": "___",
  "trailingSlash": false,
  "defaultLocaleRouteNameSuffix": "default",
  "strategy": "prefix_except_default",
  "lazy": false,
  "langDir": "locales",
  "detectBrowserLanguage": false,
  "differentDomains": false,
  "baseUrl": "",
  "dynamicRouteParams": false,
  "customRoutes": "page",
  "pages": {},
  "skipSettingLocaleOnNavigate": false,
  "types": "composition",
  "debug": false,
  "parallelPlugin": false,
  "i18nModules": []
}

export const normalizedLocales = [
  {
    "code": "en",
    "iso": "en-US",
    "name": "English",
    "dir": "ltr",
    "files": [
      {
        "path": "locales/en.json"
      }
    ]
  },
  {
    "code": "ru",
    "iso": "ru-RU",
    "name": "Russian",
    "dir": "ltr",
    "files": [
      {
        "path": "locales/ru.json"
      }
    ]
  },
  {
    "code": "tr",
    "iso": "tr-TR",
    "name": "Turkish",
    "dir": "ltr",
    "files": [
      {
        "path": "locales/tr.json"
      }
    ]
  },
  {
    "code": "de",
    "dir": "ltr",
    "iso": "de-DE",
    "name": "German",
    "files": [
      {
        "path": "locales/de.json"
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false

export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18n"
export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
